import { render, staticRenderFns } from "./b-footer.vue?vue&type=template&id=bf9e18c6&"
import script from "./b-footer.vue?vue&type=script&lang=js&"
export * from "./b-footer.vue?vue&type=script&lang=js&"
import style0 from "./b-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports